import React from 'react';
import Navbar from '../components/site/Navbar';
import Footer from '../components/site/Footer';
import ChatWidget from '../components/site/ChatWidget';
import Portfolio from '../components/site/Portfolio';
import Seo from '../components/Seo';

export default function PortfolioPage() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Seo
        title="Portfolio & Case Studies | Hipro Technologies"
        description="Explore our client work: finance platforms, AI dashboards, logistics systems, e-learning, restaurant apps and brand campaigns — with real, measurable outcomes."
        path="/portfolio"
      />
      <Navbar />
      <div className="pt-20" data-testid="portfolio-page">
        <Portfolio showViewAll={false} />
      </div>
      <Footer />
      <ChatWidget />
    </div>
  );
}
